"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GallerySlider = void 0;
const nuka_carousel_1 = __importDefault(require("nuka-carousel"));
const react_1 = __importStar(require("react"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const gallery_slider_styles_1 = require("./gallery-slider.styles");
function GallerySlider(props) {
    const { items, initialSlide = 0, className, rightArrow, leftArrow, isOverlay = false, isAutoPlay = false, bottomControl, setCurrentItem, onChangeSlide, galleryApi, children, renderItem, } = props;
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const [slide, setSlide] = (0, react_1.useState)(initialSlide);
    const [isSwipeHintShown, , hideSwipeHint] = (0, libs_hooks_react_1.useToggleState)(true);
    const currentMediaItem = items[slide];
    const manualAction = (0, react_1.useRef)(false);
    const { show: showBottomControl = false, styles: bottomControlStyles } = bottomControl || {};
    const handleCenterBottomControl = showBottomControl
        ? {
            defaultControlsConfig: {
                pagingDotsStyle: (bottomControlStyles === null || bottomControlStyles === void 0 ? void 0 : bottomControlStyles.pagingDotsStyle) || {},
                pagingDotsContainerClassName: (bottomControlStyles === null || bottomControlStyles === void 0 ? void 0 : bottomControlStyles.pagingDotsContainerClassName) || '',
            },
        }
        : { renderBottomCenterControls: null };
    if (galleryApi) {
        galleryApi.current = { setSlide };
    }
    return (react_1.default.createElement(gallery_slider_styles_1.CarouselWrapper, { className: className, isOverlay: isOverlay },
        react_1.default.createElement(gallery_slider_styles_1.CarouselBody, null,
            react_1.default.createElement(nuka_carousel_1.default, Object.assign({ dragging: mobile, slideIndex: slide, autoplay: isAutoPlay, beforeSlide: (_, currentSlide) => {
                    if (manualAction.current) {
                        setCurrentItem === null || setCurrentItem === void 0 ? void 0 : setCurrentItem(items[currentSlide]);
                    }
                    manualAction.current = false;
                }, afterSlide: currentSlide => {
                    setSlide(currentSlide);
                    onChangeSlide === null || onChangeSlide === void 0 ? void 0 : onChangeSlide(items[currentSlide], currentSlide);
                }, wrapAround: true, onDragStart: () => {
                    manualAction.current = true;
                    hideSwipeHint();
                }, renderCenterLeftControls: ({ previousSlide }) => {
                    return (react_1.default.createElement("button", { onClick: () => {
                            manualAction.current = true;
                            previousSlide();
                        } }, leftArrow || (react_1.default.createElement(gallery_slider_styles_1.Chevron, { name: "chevron-big-left", enable: (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.__typename) === 'VideoMediaItem' }))));
                }, renderCenterRightControls: ({ nextSlide }) => {
                    return (react_1.default.createElement("button", { onClick: () => {
                            manualAction.current = true;
                            nextSlide();
                        } }, rightArrow || (react_1.default.createElement(gallery_slider_styles_1.Chevron, { name: "chevron-big-right", enable: (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.__typename) === 'VideoMediaItem' }))));
                } }, handleCenterBottomControl), items.map(renderItem))),
        isSwipeHintShown && items.length !== 1 && react_1.default.createElement(gallery_slider_styles_1.SwipeIcon, null),
        typeof children === 'function' ? children(slide) : children));
}
exports.GallerySlider = GallerySlider;
//# sourceMappingURL=gallery-slider.js.map